import type { TRuleWithTheme } from '@/styles/theme';

const submenuShadow = '0px 2px 16px 0px rgba(27, 27, 126, 0.15)';

export const container: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    minWidth: '200px',
    padding: theme.spacing(8),
    borderRadius: theme.spacing(8),
    backgroundColor: theme.colors.backgroundsSecondary,
    boxShadow: submenuShadow,
});

export const option: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(8),
    height: '32px',
    padding: `0 ${theme.spacing(8)}`,
    border: 'none',
    borderRadius: theme.spacing(4),
    backgroundColor: 'transparent',
    cursor: 'pointer',
    textAlign: 'left',
    ...theme.typography.ParagraphSmallMedium,
    color: theme.colors.foregroundsPrimary,

    ':hover': {
        backgroundColor: theme.colors.listItemHoverBg,
    },
});

export const optionActive: TRuleWithTheme = ({ theme }) => ({
    backgroundColor: theme.colors.listItemSelectedBg,
    color: theme.colors.accentPrimary,

    ':hover': {
        backgroundColor: theme.colors.listItemSelectedBg,
    },
});

// Fixed-width leading box so the check icon's presence/absence doesn't shift
// the label (matches the Figma's indented inactive option).
export const check: TRuleWithTheme = () => ({
    display: 'inline-flex',
    flexShrink: 0,
    width: '16px',
    height: '16px',
});
